import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpEventType, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments';
import { Observable, throwError as _throw} from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ThirdPartyEvaluationFormItemFile } from '../models/thirdparty-evaluation-form-item-file';
import { FileByEvaluationAndForm } from '@app/models/file-item';
import { ArrayUtilsService } from '@app/core/_base/crud/utils/array-utils.service';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  private apiEndPoint: string;

  constructor(
    private _http: HttpClient,
    private _translate: TranslateService,
    private arrayUtils: ArrayUtilsService
  ) {
    this.apiEndPoint = environment.apiUrl;
    
  }

  postFile(file: ThirdPartyEvaluationFormItemFile): Observable<any> {
    return this._http
      .post(`${this.apiEndPoint}/Files`, file)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(err => {
          if (err.errorcode) {
            return _throw(err.errorcode);
          }
          return _throw(this._translate.instant('BUSSINESSERRORS.ErrUnexpected'));
        })
      );
  }

  deleteFile(fileId: number): Observable<any> {
    return this._http
      .delete(`${this.apiEndPoint}/Files/${fileId}`)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(err => {
          if (err.errorcode) {
            return _throw(err.errorcode);
          }
          return _throw(this._translate.instant('BUSSINESSERRORS.ErrUnexpected'));
        })
      );
  }

  deleteRequestAnswerFile(fileId: number): Observable<any> {
    return this._http
      .delete(`${this.apiEndPoint}/Files/DueDiligenceRequestAnswer/${fileId}`)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(err => {
          if (err.errorcode) {
            return _throw(err.errorcode);
          }
          return _throw(this._translate.instant('BUSSINESSERRORS.ErrUnexpected'));
        })
      );
  }

  deleteTracingTaskFile(fileId: number, taskId: number): Observable<any> {
    const params = new HttpParams()
      .append("fileId", fileId.toString())
      .append("thirdPartyEvaluationFollowUpId", taskId.toString());

    return this._http
      .delete(`${this.apiEndPoint}/Task/DeleteFollowUpTaskFile`, { params })
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(err => {
          if (err.errorcode) {
            return _throw(err.errorcode);
          }
          return _throw(this._translate.instant('BUSSINESSERRORS.ErrUnexpected'));
        })
      );
  }


  deleteTracingSubTaskFile(fileId: number, subTaskId: number): Observable<any> {
    const params = new HttpParams()
      .append("fileId", fileId.toString())
      .append("followUpSubTaskId", subTaskId.toString());

    return this._http
      .delete(`${this.apiEndPoint}/Task/DeleteFollowUpSubTaskFile`, { params })
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(err => {
          if (err.errorcode) {
            return _throw(err.errorcode);
          }
          return _throw(this._translate.instant('BUSSINESSERRORS.ErrUnexpected'));
        })
      );
  }



  downloadFile(fileId: number, evaluationId: number): Observable<any> {
    return this._http
      .get(`${this.apiEndPoint}/Files/${fileId}/${evaluationId}`, { responseType: 'blob' })
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(err => {
          if (err.errorcode) {
            return _throw(err.errorcode);
          }
          return _throw(this._translate.instant('BUSSINESSERRORS.ErrUnexpected'));
        })
      );
  }

  downloadThirdPartyFollowUpFile(thridPartyFollowUpFormItemId: number, fileId: number) {
    return this._http
      .get(`${this.apiEndPoint}/Files/GetFileForFollowUpTaskItem/${thridPartyFollowUpFormItemId}/${fileId}`, { responseType: 'blob' })
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(err => {
          if (err.errorcode) {
            return _throw(err.errorcode);
          }
          return _throw(this._translate.instant('BUSSINESSERRORS.ErrUnexpected'));
        })
      );
  }

  downloadDueDiligenceRequestFile(fileId, requestId): Observable<any> {
    return this._http
      .get(`${this.apiEndPoint}/Files/DueDiligenceRequest/${fileId}/${requestId}`, { responseType: 'blob' })
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(err => {
          if (err.errorcode) {
            return _throw(err.errorcode);
          }
          return _throw(this._translate.instant('BUSSINESSERRORS.ErrUnexpected'));
        })
      );
  }

  downloadDueDiligenceRequestAnswerFile(fileId, requestAnswerId): Observable<any> {
    return this._http
      .get(`${this.apiEndPoint}/Files/DueDiligenceRequestAnswer/${fileId}/${requestAnswerId}`, { responseType: 'blob' })
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(err => {
          if (err.errorcode) {
            return _throw(err.errorcode);
          }
          return _throw(this._translate.instant('BUSSINESSERRORS.ErrUnexpected'));
        })
      );
  }

  downloadTracingTaskFile(fileId, taskId): Observable<any> {
    return this._http
      .get(`${this.apiEndPoint}/Files/TracingTask/${fileId}/${taskId}`, { responseType: 'blob' })
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(err => {
          if (err.errorcode) {
            return _throw(err.errorcode);
          }
          return _throw(this._translate.instant('BUSSINESSERRORS.ErrUnexpected'));
        })
      );
  }

  downloadTracingSubTaskFile(fileId, subTaskId): Observable<any> {
    return this._http
      .get(`${this.apiEndPoint}/Files/TracingSubTask/${fileId}/${subTaskId}`, { responseType: 'blob' })
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(err => {
          if (err.errorcode) {
            return _throw(err.errorcode);
          }
          return _throw(this._translate.instant('BUSSINESSERRORS.ErrUnexpected'));
        })
      );
  }

  getFilesByEvaluation(evaluationId): Observable<any[]> {
    return this._http
      .get(`${this.apiEndPoint}/Files/${evaluationId}`)
      .pipe(
        map(response => {
          return response as Array<any>;
        }),
        catchError(err => {
          if (err.errorcode) {
            return _throw(err.errorcode);
          }
          return _throw(this._translate.instant('BUSSINESSERRORS.ErrUnexpected'));
        })
      );
  }

  getFilesByEvaluationAndForm(evaluationId, formId): Observable<FileByEvaluationAndForm[]> {
    return this._http
      .get<FileByEvaluationAndForm[]>(`${this.apiEndPoint}/Files/GetAllByThirdPartyEvaluationAndFormId/${evaluationId}/${formId}`)
      .pipe(
        map(response => {
          // response = this.getDuplicatedFilesFiltered(response);
          return response as Array<FileByEvaluationAndForm>;
        }),
        catchError(err => {
          if (err.errorcode) {
            return _throw(err.errorcode);
          }
          return _throw(this._translate.instant('BUSSINESSERRORS.ErrUnexpected'));
        })
      );
  }

  // getDuplicatedFilesFiltered(files: FileByEvaluationAndForm[]): FileByEvaluationAndForm[] {
  //   let filesInAnswers: FileByEvaluationAndForm[] = [];

  //   for(let fileResponse of files) {
  //     if (!filesInAnswers.some(fileA => fileA.thirdPartyEvaluationFormItemId === fileResponse.thirdPartyEvaluationFormItemId)) {
  //       filesInAnswers.push(fileResponse);
  //     } else {
  //       filesInAnswers.forEach(fileA => {
  //         if (fileA.thirdPartyEvaluationFormItemId === fileResponse.thirdPartyEvaluationFormItemId &&
  //           fileA.file.id !== fileResponse.file.id) {
  //             filesInAnswers.push(fileResponse);
  //           }
  //       });
  //     }
  //   }
  //   return filesInAnswers;
  // }

  postFileWithProgress(file: ThirdPartyEvaluationFormItemFile): Observable<{progress: number, response?: ThirdPartyEvaluationFormItemFile}> {
    return this._http
      .post<number>(`${this.apiEndPoint}/Files`, file, {reportProgress: true, observe: 'events'})
      .pipe(
        map(ev => {
          switch(ev.type) {
            case HttpEventType.UploadProgress:
              return {
                progress: (ev.loaded / ev.total) * 100,
              };
            case HttpEventType.Response:
              return {
                progress: 100,
                response: {
                  ...file,
                  id: ev.body,
                }
              };
            case HttpEventType.DownloadProgress:
              return {
                progress: 101,
              }
            default:
              return {
                progress: 0,
              }
          }
        })
      )
  }
}
